import { motion } from "framer-motion";
import { BadgeCheck } from "lucide-react";

const ENTRIES = [
  { name: "Kwame O.", location: "Accra, Ghana", time: "2 mins ago", status: "Subscribed & Commented" },
  { name: "Tunde A.", location: "Lagos, Nigeria", time: "5 mins ago", status: "Subscribed & Liked" },
  { name: "Sipho M.", location: "Johannesburg, SA", time: "8 mins ago", status: "Subscribed, Liked & Commented" },
  { name: "Amina K.", location: "Nairobi, Kenya", time: "12 mins ago", status: "Subscribed & Commented" },
  { name: "Chidi E.", location: "Abuja, Nigeria", time: "17 mins ago", status: "Subscribed, Liked & Commented" },
  { name: "Naledi P.", location: "Gaborone, Botswana", time: "24 mins ago", status: "Subscribed & Liked" },
];

export default function Activity() {
  return (
    <section data-testid="activity-section" className="px-4 py-24 sm:px-6">
      <div className="mx-auto max-w-4xl">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="mb-12 text-center"
        >
          <p className="mb-3 flex items-center justify-center gap-2 text-xs font-mono font-bold uppercase tracking-[0.3em] text-emerald-400">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-75" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-emerald-400" />
            </span>
            Live Community Entries
          </p>
          <h2 className="font-display text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl lg:text-4xl">
            Africa Is Entering Right Now
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-base text-slate-500">
            The random draw happens live on YouTube the moment the 48-hour timer reaches zero.
          </p>
        </motion.div>

        <div className="space-y-3">
          {ENTRIES.map((entry, i) => (
            <motion.div
              key={entry.name}
              data-testid={`activity-entry-${i}`}
              initial={{ opacity: 0, x: -24 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="flex items-center gap-4 rounded-xl border border-slate-200 bg-[#F4F4F5] px-5 py-4"
            >
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-red-500 to-red-700 font-display text-sm font-extrabold text-white">
                {entry.name.charAt(0)}
              </span>
              <div className="min-w-0 flex-1">
                <p className="truncate text-sm font-bold text-slate-800">
                  {entry.name} <span className="font-normal text-slate-500">· {entry.location}</span>
                </p>
                <p className="flex items-center gap-1.5 text-xs text-emerald-400">
                  <BadgeCheck className="h-3.5 w-3.5" />
                  {entry.status}
                </p>
              </div>
              <span className="shrink-0 font-mono text-xs text-slate-500">{entry.time}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
